import { render } from "./SwdSideBar.vue?vue&type=template&id=2891b926&scoped=true"
import script from "./SwdSideBar.vue?vue&type=script&lang=js"
export * from "./SwdSideBar.vue?vue&type=script&lang=js"

import "./SwdSideBar.vue?vue&type=style&index=0&id=2891b926&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2891b926"]])

export default __exports__